// extracted by mini-css-extract-plugin
export default {"container":"LQWBDK2dihsEIPN567fx","title":"dqwtZge4qb9c4_HGTsDd","tabs":"FRkt8sGuX9QevtWI8GZA"};